import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { Dashboard } from './pages/Dashboard';
import { SupplierList } from './pages/SupplierList';
import { SupplierForm } from './pages/SupplierForm';
import { GenericApprovalList } from './pages/GenericApprovalList';
import { GenericApprovalAction } from './pages/GenericApprovalAction';
import { SupplierKPIReport } from './pages/SupplierKPIReport';
import { SupplierKPIDetail } from './pages/SupplierKPIDetail';
import { PurchaseRequisitionList } from './pages/PurchaseRequisitionList';
import { PurchaseRequisitionForm } from './pages/PurchaseRequisitionForm';
import { PurchaseOrderList } from './pages/PurchaseOrderList';
import { PurchaseOrderForm } from './pages/PurchaseOrderForm';
import { ProductList } from './pages/ProductList';
import { ProductForm } from './pages/ProductForm';
import { RequisitionList } from './pages/RequisitionList';
import { RequisitionForm } from './pages/RequisitionForm';
import { RequisitionApprovalList } from './pages/RequisitionApprovalList';
import { RequisitionApprovalAction } from './pages/RequisitionApprovalAction';
import { ReceiveList } from './pages/ReceiveList';
import { ReceiveForm } from './pages/ReceiveForm';
import { QCList } from './pages/QCList';
import { QCAction } from './pages/QCAction';
import { GRNList } from './pages/GRNList';
import { GRNReport } from './pages/GRNReport';
import { DisposalRepairList } from './pages/DisposalRepairList';
import { DisposalRepairAction } from './pages/DisposalRepairAction';
import { StockList } from './pages/StockList';
import { StockHistory } from './pages/StockHistory';
import { StockInForm } from './pages/StockInForm';
import { StockOutForm } from './pages/StockOutForm';
import { StockIssueForm } from './pages/StockIssueForm';
import { StockTransferList } from './pages/StockTransferList';
import { StockTransferForm } from './pages/StockTransferForm';
import { StockThresholdList } from './pages/StockThresholdList';
import { StockThresholdForm } from './pages/StockThresholdForm';
import { TenderBoard } from './pages/TenderBoard';
import { EOISubmission } from './pages/EOISubmission';
import { RFPSubmission } from './pages/RFPSubmission';
import { MasterSettingsList } from './pages/MasterSettingsList';
import { MasterSettingsForm } from './pages/MasterSettingsForm';
import { HomePage } from './pages/HomePage';
import { AnnualProcurementPlan } from './pages/AnnualProcurementPlan';
import { AnnualPlanList } from './pages/AnnualPlanList';
import { EOIList } from './pages/EOIList';
import { EOIAction } from './pages/EOIAction';
import { RFPList } from './pages/RFPList';
import { RFPAction } from './pages/RFPAction';
import { RFQList } from './pages/RFQList';
import { RFQAction } from './pages/RFQAction';
import { NOAList } from './pages/NOAList';
import { NOAAction } from './pages/NOAAction';
import { NegotiationList } from './pages/NegotiationList';
import { NegotiationAction } from './pages/NegotiationAction';
import { NegotiationCreate } from './pages/NegotiationCreate';
export function App() {
  return <HashRouter data-id="element-0">
      <Routes data-id="element-1">
        {/* Supplier Portal (No Sidebar layout for signup, or use layout if preferred. Using layout for consistency) */}
        <Route path="/supplier-signup" element={<AppLayout data-id="element-3" />} data-id="element-2">
          <Route index element={<SupplierForm mode="signup" data-id="element-5" />} data-id="element-4" />
        </Route>

        {/* Home Page — no sidebar */}
        <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />

        <Route path="/" element={<AppLayout data-id="element-9" />} data-id="element-8">
          <Route path="dashboard" element={<Dashboard data-id="element-11" />} data-id="element-10" />

          {/* Supplier Management */}
          <Route path="suppliers" element={<SupplierList data-id="element-13" />} data-id="element-12" />
          <Route path="suppliers/create" element={<SupplierForm mode="create" data-id="element-15" />} data-id="element-14" />
          <Route path="suppliers/:id/edit" element={<SupplierForm mode="edit" data-id="element-17" />} data-id="element-16" />
          <Route path="supplier-approval" element={<GenericApprovalList type="supplier" data-id="element-19" />} data-id="element-18" />
          <Route path="supplier-approval/:id" element={<GenericApprovalAction type="supplier" data-id="element-21" />} data-id="element-20" />
          <Route path="supplier-kpi" element={<SupplierKPIReport data-id="element-23" />} data-id="element-22" />
          <Route path="supplier-kpi/:id" element={<SupplierKPIDetail data-id="element-25" />} data-id="element-24" />

          {/* Procurement */}
          <Route path="procurement-plan" element={<AnnualPlanList data-id="element-27" />} data-id="element-26" />
          <Route path="procurement-plan/create" element={<AnnualProcurementPlan data-id="element-29" />} data-id="element-28" />
          <Route path="procurement-plan/:id" element={<AnnualProcurementPlan data-id="element-31" />} data-id="element-30" />
          <Route path="procurement-plan/:id/edit" element={<AnnualProcurementPlan data-id="element-33" />} data-id="element-32" />

          <Route path="purchase-requisitions" element={<PurchaseRequisitionList data-id="element-35" />} data-id="element-34" />
          <Route path="purchase-requisitions/create" element={<PurchaseRequisitionForm data-id="element-37" />} data-id="element-36" />
          <Route path="purchase-requisitions/:id/edit" element={<PurchaseRequisitionForm data-id="element-39" />} data-id="element-38" />

          <Route path="pr-approval" element={<GenericApprovalList type="pr" data-id="element-41" />} data-id="element-40" />
          <Route path="pr-approval/:id" element={<GenericApprovalAction type="pr" data-id="element-43" />} data-id="element-42" />
          <Route path="eoi-approval" element={<GenericApprovalList type="eoi" data-id="element-45" />} data-id="element-44" />
          <Route path="eoi-approval/:id" element={<GenericApprovalAction type="eoi" data-id="element-47" />} data-id="element-46" />
          <Route path="rfp-approval" element={<GenericApprovalList type="rfp" data-id="element-49" />} data-id="element-48" />
          <Route path="rfp-approval/:id" element={<GenericApprovalAction type="rfp" data-id="element-51" />} data-id="element-50" />
          <Route path="rfq-approval" element={<GenericApprovalList type="rfq" data-id="element-53" />} data-id="element-52" />
          <Route path="rfq-approval/:id" element={<GenericApprovalAction type="rfq" data-id="element-55" />} data-id="element-54" />
          <Route path="noa-approval" element={<GenericApprovalList type="noa" data-id="element-57" />} data-id="element-56" />
          <Route path="noa-approval/:id" element={<GenericApprovalAction type="noa" data-id="element-59" />} data-id="element-58" />
          <Route path="annual-plan-approval" element={<GenericApprovalList type="annual-plan" data-id="element-61" />} data-id="element-60" />
          <Route path="annual-plan-approval/:id" element={<GenericApprovalAction type="annual-plan" data-id="element-63" />} data-id="element-62" />

          <Route path="eoi" element={<EOIList data-id="element-65" />} data-id="element-64" />
          <Route path="eoi/:id" element={<EOIAction data-id="element-67" />} data-id="element-66" />
          <Route path="rfp" element={<RFPList data-id="element-69" />} data-id="element-68" />
          <Route path="rfp/:id" element={<RFPAction data-id="element-71" />} data-id="element-70" />
          <Route path="rfq" element={<RFQList data-id="element-73" />} data-id="element-72" />
          <Route path="rfq/:id" element={<RFQAction data-id="element-75" />} data-id="element-74" />
          <Route path="noa" element={<NOAList data-id="element-77" />} data-id="element-76" />
          <Route path="noa/:id" element={<NOAAction data-id="element-79" />} data-id="element-78" />
          <Route path="negotiation" element={<NegotiationList data-id="element-81" />} data-id="element-80" />
          <Route path="negotiation/create" element={<NegotiationCreate data-id="element-83" />} data-id="element-82" />
          <Route path="negotiation/:id" element={<NegotiationAction data-id="element-85" />} data-id="element-84" />

          {/* Purchase Orders */}
          <Route path="purchase-orders" element={<PurchaseOrderList data-id="element-87" />} data-id="element-86" />
          <Route path="purchase-orders/create" element={<PurchaseOrderForm data-id="element-89" />} data-id="element-88" />
          <Route path="purchase-orders/:id/edit" element={<PurchaseOrderForm data-id="element-91" />} data-id="element-90" />
          <Route path="po-approval" element={<GenericApprovalList type="po" data-id="element-93" />} data-id="element-92" />
          <Route path="po-approval/:id" element={<GenericApprovalAction type="po" data-id="element-95" />} data-id="element-94" />

          {/* Inventory & QC */}
          <Route path="products" element={<ProductList data-id="element-97" />} data-id="element-96" />
          <Route path="products/create" element={<ProductForm data-id="element-99" />} data-id="element-98" />
          <Route path="products/:id/edit" element={<ProductForm data-id="element-101" />} data-id="element-100" />
          <Route path="requisitions" element={<RequisitionList data-id="element-103" />} data-id="element-102" />
          <Route path="requisitions/create" element={<RequisitionForm data-id="element-105" />} data-id="element-104" />
          <Route path="requisitions/:id/edit" element={<RequisitionForm data-id="element-107" />} data-id="element-106" />
          <Route path="requisition-approval" element={<RequisitionApprovalList data-id="element-109" />} data-id="element-108" />
          <Route path="requisition-approval/:id" element={<RequisitionApprovalAction data-id="element-111" />} data-id="element-110" />
          <Route path="receives" element={<ReceiveList data-id="element-113" />} data-id="element-112" />
          <Route path="receives/create" element={<ReceiveForm data-id="element-115" />} data-id="element-114" />
          <Route path="receives/:id/edit" element={<ReceiveForm data-id="element-117" />} data-id="element-116" />
          <Route path="qc" element={<QCList data-id="element-119" />} data-id="element-118" />
          <Route path="qc/:id" element={<QCAction data-id="element-121" />} data-id="element-120" />
          <Route path="grn" element={<GRNList data-id="element-123" />} data-id="element-122" />
          <Route path="grn/:id" element={<GRNReport data-id="element-125" />} data-id="element-124" />
          <Route path="disposal-repair" element={<DisposalRepairList data-id="element-127" />} data-id="element-126" />
          <Route path="disposal-repair/:id" element={<DisposalRepairAction data-id="element-129" />} data-id="element-128" />
          <Route path="stock-thresholds" element={<StockThresholdList data-id="element-131" />} data-id="element-130" />
          <Route path="stock-thresholds/create" element={<StockThresholdForm data-id="element-133" />} data-id="element-132" />
          <Route path="stock-thresholds/:id/edit" element={<StockThresholdForm data-id="element-135" />} data-id="element-134" />

          {/* Stock Management */}
          <Route path="stock" element={<StockList data-id="element-137" />} data-id="element-136" />
          <Route path="stock/history" element={<StockHistory data-id="element-139" />} data-id="element-138" />
          <Route path="stock/in" element={<StockInForm data-id="element-141" />} data-id="element-140" />
          <Route path="stock/out" element={<StockOutForm data-id="element-143" />} data-id="element-142" />
          <Route path="stock/issue" element={<StockIssueForm data-id="element-145" />} data-id="element-144" />
          <Route path="stock/transfer" element={<StockTransferList data-id="element-147" />} data-id="element-146" />
          <Route path="stock/transfer/create" element={<StockTransferForm data-id="element-149" />} data-id="element-148" />

          {/* Master Settings */}
          <Route path="master-settings/:type" element={<MasterSettingsList data-id="element-151" />} data-id="element-150" />
          <Route path="master-settings/:type/create" element={<MasterSettingsForm data-id="element-153" />} data-id="element-152" />
          <Route path="master-settings/:type/:id/edit" element={<MasterSettingsForm data-id="element-155" />} data-id="element-154" />

          {/* Supplier Portal */}
          <Route path="tender-board" element={<TenderBoard data-id="element-157" />} data-id="element-156" />
          <Route path="tender-board/eoi/:id/submit" element={<EOISubmission data-id="element-159" />} data-id="element-158" />
          <Route path="tender-board/rfp/:id/submit" element={<RFPSubmission data-id="element-161" />} data-id="element-160" />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace data-id="element-163" />} data-id="element-162" />
        </Route>
      </Routes>
    </HashRouter>;
}